{
    "RestNoContentError": "Le contenu de la réponse était attendu mais aucune n'a été donnée",
    "RestJsonProcessing": "Erreur de traitement de JSON",
    "NAME": "LanguageErrors",
    "UnhandlableError": "Le service Akixi a émis une erreur impossible à traiter.",
    "UnknownError": "Il y a eu une erreur de serveur inconnu"
}